const formatCallDuration = (seconds) => {
  const total = Math.round(Number(seconds));
  if (!Number.isFinite(total) || total <= 0) return '0s';

  const minutes = Math.floor(total / 60);
  const remainder = total % 60;

  if (!minutes) return `${remainder}s`;
  return remainder ? `${minutes}m ${remainder}s` : `${minutes}m`;
};

export default formatCallDuration;
